export interface ITaxAssessment {
    Index: number;
    Year: number;
    Amount: number;
    AmountAsText: string;
    PercentChange: number;
    IsPosChange: boolean;
    IsNegChange: boolean;
}

export class TaxAssessment implements ITaxAssessment {

    public Index: number;
    public Year: number;
    public Amount: number;
    public AmountAsText: string;
    public PercentChange: number;
    public IsPosChange: boolean;
    public IsNegChange: boolean;
    constructor(
        index: number, year: number, amount: number, amountAsText: string,
        percentChange: number, isPosChange: boolean, isNegChange: boolean,
    ) {
        this.Index = index;
        this.Year = year;
        this.Amount = amount;
        this.AmountAsText = amountAsText;
        this.PercentChange = percentChange;
        this.IsPosChange = isPosChange;
        this.IsNegChange = isNegChange;
    }
}
